module.exports = __webpack_public_path__ + "images/affd812cfaaaacd9dc903d1cde691190.png";